import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { BlackHoleParticleShader } from "../shaders/blackHoleParticles";

export function BlackHoleParticles() {
  const ref = useRef();
  const count = 25000;

  const [positions, randomness] = useMemo(() => {
    const pos = new Float32Array(count * 3);
    const rand = new Float32Array(count);
    for (let i = 0; i < count; i++) {
      const r = Math.random() * 15 + 0.5;
      const theta = Math.random() * Math.PI * 2;
      pos[i * 3] = Math.cos(theta) * r;
      pos[i * 3 + 1] = 0;
      pos[i * 3 + 2] = Math.sin(theta) * r;
      rand[i] = Math.random();
    }
    return [pos, rand];
  }, []);

  useFrame((state) => {
    if (ref.current) {
      ref.current.uniforms.time.value = state.clock.elapsedTime;
    }
  });

  return (
    <points>
      <bufferGeometry>
        <bufferAttribute
          attach="attributes-initialPos"
          array={positions}
          count={count}
          itemSize={3}
        />
        <bufferAttribute
          attach="attributes-aRandom"
          array={randomness}
          count={count}
          itemSize={1}
        />
        <bufferAttribute
          attach="attributes-position"
          array={positions}
          count={count}
          itemSize={3}
        />
      </bufferGeometry>
      <shaderMaterial ref={ref} args={[BlackHoleParticleShader]} />
    </points>
  );
}
